import { useState } from "react";
import { ALL_ICONS } from "../../../assets/icons/AllIcons";
import "./DateRangeComponent.css";
import { RazorButton, RazorInputField } from "../../razor-reuse";
import { formatDateToYYYYMMDD } from "../../../utils/Helper";

interface MyComponentProps {
  value?: string;
  onSet?: (param?: any) => void;
  onCancel?: () => void;
  onOpen?: () => void;
}

const DateRangeComponent = ({
  value,
  onSet,
  onCancel,
  onOpen,
}: MyComponentProps) => {
  const [showModal, setShowModal] = useState<boolean>(false);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");

  //   const startDateRef = useRef<HTMLDivElement>(null);
  //   const endDateRef = useRef<HTMLDivElement>(null);

  //   const dropDownRRef = useOnClickOutsideThree(() => {
  //     setShowModal(false);
  //   }, [startDateRef]);

  const handleFinish = () => {
    // e && e.stopPropagation();
    const val = `${startDate},${endDate}`;
    onSet && onSet(val);
    setShowModal(false);
  };

  const handleCancel = () => {
    setStartDate("");
    setEndDate("");
    onCancel && onCancel();
  };

  return (
    <>
      <div className="date-range-index-wrapper-box">
        {/* click component start */}
        <div
          onClick={() => {
            setShowModal(!showModal);
            showModal && onOpen && onOpen();
          }}
          className="date-range-click-box"
        >
          <div className="img-value-box">
            <div className="img-wrap">
              <figure className="img-box">{ALL_ICONS?.calendar_icon}</figure>
            </div>
            <p className="value">{value || `Date range`}</p>
            {!value && (
              <div className="drop-icon">
                <figure className="img-box">{ALL_ICONS?.down_chevron}</figure>
              </div>
            )}
          </div>
          {/* cancel here start */}
          {value && (
            <div
              onClick={(e) => {
                e.stopPropagation();
                handleCancel();
              }}
              className="cancel-box"
            >
              <figure className="img-box">{ALL_ICONS?.close_modal}</figure>
            </div>
          )}
          {/* cancel here end */}
        </div>
        {/* click component end */}
        {/* drop here start */}
        {showModal && (
          <div
            // onClick={() => {
            //   setShowModal(true);
            // }}
            className="drop-box-wrapper"
          >
            <div className="title-text-box">
              <p className="title">Date Range</p>
              <p className="text">
                Select the start date and end date for <br /> your transcations
              </p>
            </div>
            {/* form part start */}
            <div className="form-part">
              <RazorInputField
                color="black-light"
                type="date"
                label="Start Date"
                placeholder=" Select date"
                onChange={(e: any) => {
                  setStartDate(formatDateToYYYYMMDD(e[0]));
                  setShowModal(true);
                }}
                value={startDate}
                dateOptions={{ maxDate: new Date() }}
                // className="flatpickr-calendar"
              />
              <RazorInputField
                color="black-light"
                type="date"
                label="End Date"
                placeholder=" Select date"
                onChange={(e: any) => {
                  setEndDate(formatDateToYYYYMMDD(e[0]));
                }}
                value={endDate}
                dateOptions={{ minDate: startDate, maxDate: new Date() }}
                disabled={!startDate}
                // className="flatpickr-calendar"
              />

              <RazorButton
                disabled={!startDate || !endDate}
                color="black-light"
                label="Apply"
                className="btn"
                onClick={handleFinish}
              />
            </div>
            {/* form part end */}
          </div>
        )}
        {/* drop here end */}
      </div>
      {/* modal here start */}
      {/* modal here end */}
    </>
  );
};

export default DateRangeComponent;
